import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import Pricing from './pages/Pricing';
import Practice from './pages/Practice';
import NotFound from './pages/NotFound';
import ScrollToHash from './components/ScrollToHash';
import useSeo from './seo';

// Applies the head tags for the current route on client-side navigation. The
// build-time equivalent is scripts/prerender.js; keep the two in step.
const Seo = () => {
  useSeo();
  return null;
};

function App() {
  return (
    <Router>
      <Seo />
      <ScrollToHash />
      <Routes>
        {/* Client login = practice-name checker (replaces the old domain check) */}
        <Route path="/login" element={<Practice />} />
        <Route path="/practice" element={<Practice />} />

        {/* Public marketing pages share the nav + footer via Layout */}
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/pricing" element={<Pricing />} />
          {/* A real 404 rather than a redirect to "/": redirecting made every
              bad URL answer 200 with the home page, which Google reads as
              duplicate content and crawls forever. */}
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
